"use client";

import { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from "react";

interface ExamContextType {
  onExitExam?: () => void;
  setOnExitExam: Dispatch<SetStateAction<(() => void) | undefined>>;
}

const ExamContext = createContext<ExamContextType | undefined>(undefined);

export function ExamProvider({ children }: { children: ReactNode }) {
  const [onExitExam, setOnExitExam] = useState<(() => void) | undefined>();

  return (
    <ExamContext.Provider value={{ onExitExam, setOnExitExam }}>
      {children}
    </ExamContext.Provider>
  );
}

export function useExam() {
  const context = useContext(ExamContext);
  if (context === undefined) {
    throw new Error("useExam must be used within an ExamProvider");
  }
  return context;
}

export function useOptionalExam() {
  return useContext(ExamContext);
}
